export default {
  "label": "_label_1swgc_1",
  "required": "_required_1swgc_5",
  "invalid": "_invalid_1swgc_11",
  "fullWidth": "_fullWidth_1swgc_14",
  "wrapper": "_wrapper_1swgc_17"
};import "ni:sha-256;SSeg6Fct-QoHKazrOUfSK8mtT33ZRXHtglFSzs6_sG8";